import styled from "styled-components";

export const PageContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`
export const PageWrapper = styled.div`
    text-align: center;
    & svg{
        font-size: 48px;
        margin: .5em;
        color: #c12828;
    }
    & h3{
        font-size: 1em;
    }
`